/**
 * Route predicates that more than one component has to agree on.
 */

// The workshop portal's care service tab, which is also its landing route.
// HomeWorkshopUser uses this to stay off the care service vehicle list's Redux
// slot while that list owns it (see utils/listState).
export function isCareServiceRoute(pathname) {
  if (!pathname) {
    return false;
  }
  return pathname === '/' || /^\/workshop\/[^/]+\/care-service\/?$/.test(pathname);
}
